module.exports = __webpack_public_path__ + "img/shenhese.2f34327c.png";